<template>
  <RegionalBenefit>
    {{ i18n(translations.title) }}
    <template #appendix>
      <div class="space-y-24">
        <div>
          <h4>{{ i18n(translations.europeTitle) }}</h4>
          {{ i18n(translations.europeBody) }}
        </div>

        <div>
          <h4>{{ i18n(translations.domTitle) }}</h4>
          {{ i18n(translations.domBody) }}
        </div>
      </div>
    </template>
  </RegionalBenefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import RegionalBenefit from '../RegionalBenefit/RegionalBenefit.vue'

import translations from './Plan90goFrance25goEurope.translations'

const i18n = useI18n()
</script>
